export default __webpack_public_path__ + "static/media/fireflink_cloud.d1fe5fef.svg";